import { DefineEntity, Entity2D, EntityType, Vector2 } from '../../../odie';
import { GameScene } from '../../GameScene';
import { BlockComponent } from '../../components/BlockComponent';
import { PositionComponent } from '../../components/PositionComponent';
import { BlockProps } from '../../defs/block';
import { BlockDef } from '../../defs/map';
import { _spawnBaseBlockEntity } from '../../entities/BlockEntity';
import { PiggyBankBlockComponent } from './PiggyBankBlockComponent';
import { PiggyBankBlockProps } from './PiggyBankBlock';

const PiggyBankBlockEntityDef = DefineEntity(
  Entity2D,
  PositionComponent,
  BlockComponent,
  PiggyBankBlockComponent,
);
export type PiggyBankBlockEntity = EntityType<typeof PiggyBankBlockEntityDef>;

export function _spawnPiggyBankBlockEntity(
  scene: GameScene,
  def: BlockDef,
  props: BlockProps,
  position: Vector2,
): PiggyBankBlockEntity {
  const entity = _spawnBaseBlockEntity(
    PiggyBankBlockEntityDef,
    scene,
    def.id,
    props,
    position,
    {
      blockPiggyBank: {
        props: props as PiggyBankBlockProps,
        option: def.option,
      },
    },
  );

  entity.c.view2d.view.addChild(entity.c.blockPiggyBank.view);

  return entity;
}
